// axios
import axios, { isAxiosError } from 'axios';
import { STATUS_NO_TOKEN } from '@/constants';
import { i18n } from '@/i18n';
import router from '@/router';
import store from '@/store/store';
import config from './config';

/**
 * Создаем axios экземпляр для экспорта
 */
const instance =  axios.create({
    baseURL: config.api,
    timeout: 1e5,
});

instance.defaults.withCredentials = true;

/**
 * Язык интерфейса для бэка. Меняется только с перезагрузкой страницы (setLocale)
 */
instance.defaults.headers.common['app-language'] = i18n.locale;

/**
 * Добавляем interceptor на ответ после запроса
 * Если вернет 401 статус, то удаляем данные об юзере и переходим на страницу "Авторизацию"
 *
 * @return {Promise}
 */
instance.interceptors.response.use(response => response, (error) => {
    const status = isAxiosError(error) ? error.response?.status : undefined;

    if (status === STATUS_NO_TOKEN && store.getters.isAuthorized) {
        store.commit('LOGOUT');

        const isAlreadyOnAuth = router.currentRoute?.name === 'auth';

        if (!isAlreadyOnAuth) {
            router.push({ name: 'auth' });
        }
    }

    return Promise.reject(error);
});

export default instance;
